// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> weidner-apartment-homes-theme-comfy -> arctic-sun
// Generated: 2026-11-02T18:11:53.122Z
// Counts: 0 design, 37 content, 22 slot group, 1 collection binding, 7 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome To <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>The heart of a growing community</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Connected Anchorage Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Your everyday routine feels brighter with amenities at Arctic Sun. Each home features ceiling fans, dining rooms, and dishwashers for easy living. Select apartments offer large walk-in closets, private patios or balconies, and scenic views. Enjoy a cozy courtyard, on-site pet play area, controlled-access buildings, and an online portal for rent payments and service requests. On-site management and maintenance are ready to assist.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Looking to learn more about life at Arctic Sun or check availability? Contact our leasing team in Anchorage, AK, and we'll help you find the information you need. Explore our community and discover what sets us apart.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Arctic Sun offers inviting one- and two-bedroom apartments in Anchorage, AK. Every floor plan features an open dining area and bright rooms made for relaxing or working from home. Select homes include large walk-in closets and private patios or balconies, creating space for your daily essentials and a cozy retreat. Find the right fit for your living style at Arctic Sun.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a look inside Arctic Sun Apartment Homes in Anchorage, AK. Browse images of open living spaces, natural light streaming through tall windows, and modern kitchens designed for both quiet evenings and lively get-togethers. Picture yourself relaxing in the tranquil courtyard, stretching out in a spacious room, or enjoying views of green surroundings just outside your door.&nbsp;</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Arctic Sun Apartment Homes sits in midtown Anchorage's lively Arctic neighborhood. From your doorstep, it's a quick jump onto Walter J. Hickel Parkway for work or adventure. Employers like Elmendorf Air Force Base and Alaska Regional Hospital are close by. You're near local shops including Walmart and Costco, favorite restaurants, and the University of Alaska at Anchorage and Alaska Pacific University. Walk to Wilson Street Park for some fresh air, or check out E Street Theater or LaVonne's Fish Camp for unique city experiences. Every day brings new possibilities just minutes from your door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>At Arctic Sun, you're steps from Pop Carr Park, a quick stop from local shops, and surrounded by Anchorage's best restaurants. Convenient access to public transit and the Arctic Rec Center opens up even more ways to connect with the city, making it easy to run errands or enjoy a meal out. Live within ten minutes of downtown and enjoy a balanced lifestyle, whether you're commuting or relaxing at home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Searching for apartments for rent in Anchorage, AK? Come home to Arctic Sun and settle into a space where daily comforts meet lively community energy. Picture evenings lounging in your bright living room or strolling the nearby neighborhood. Enjoy a pet-friendly, welcoming setting with practical perks like on-site laundry and easy access to shopping, parks, and eateries. Here, you'll make the most of every day in a vibrant Anchorage community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover the best way to explore Arctic Sun Apartments in Anchorage, AK. Choose a guided in-person tour, schedule a personal virtual walkthrough with one of our leasing professionals, or use online tools to see the space at your pace. Explore our one- and two-bedroom layouts and outdoor courtyard so you can picture daily life before you decide. Touring restrictions may apply.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a look around Arctic Sun from wherever you are with our virtual tour experience. Picture your furniture in bright, open rooms. See the possibilities of a community courtyard and inviting apartments - all from your phone or laptop. Whether you're just starting your search or narrowing things down, our virtual tour lets you imagine living here at your own pace. Schedule a live virtual walkthrough or browse rooms online to get a closer look before your visit.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "customValue": "/apply-now",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "footer.get_in_touch_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 2,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[12].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[12].image_media.alt_text"
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021d-0bd3-708d-ae40-f332dcd4a47c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a sectional sofa, coffee table, and TV."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021d-0baf-73fa-bcaf-d3469414ab85.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen and dining area with orange countertops, white cabinets, and a dining table."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021d-0baa-7467-8a58-fd28a1160820.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A staged bedroom with a queen-sized bed, two nightstands, and a dresser."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021d-16d9-70de-9217-088a5440b45d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious living room with carpet and sliding glass doors leading to a balcony."
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021d-16ff-774e-a3a5-d1027036b9ec.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room and kitchen view of an apartment unit."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021d-147c-768f-bd0d-c2534d0fc9ee.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Sunlit Arctic Sun living room with carpet, large windows, and a sliding glass door"
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021d-34a9-74eb-81b1-525b1d7fca8a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of apartment building with red and beige siding."
      }
    }
  },
  "residentaccess.payrent_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021d-0baf-73fa-bcaf-d3469414ab85.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen and dining area with orange countertops, white cabinets, and a dining table."
      }
    }
  },
  "residentaccess.portal_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021d-0baa-7467-8a58-fd28a1160820.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A staged bedroom with a queen-sized bed, two nightstands, and a dresser."
      }
    }
  },
  "residentaccess.service_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167170/019d021d-0bd3-708d-ae40-f332dcd4a47c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a sectional sofa, coffee table, and TV."
      }
    }
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "photogallery.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_7ba193e699ebb6be3e329332",
      "ec_242a3b8e5e7e6a87aebd503d",
      "ec_ce053e55bf1057263007cf1d",
      "ec_3fc10d046f6519e299a8c7be",
      "ec_ca02cfeeae5ae975d39f3712",
      "ec_dc8603441bb633533d3e3ecd",
      "ec_be174a10aa7eca2ae5011e22",
      "ec_091d8b69cdb6b86583f15e8a",
      "ec_de4287aad2d800d768de5ffa",
      "ec_55162b604768e51463258f94",
      "ec_ad16407c799fc1b4cbe30c98",
      "ec_65ad018a6b59d865f81a795d",
      "ec_e6da928a4fe2a4a83302b219"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
